import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Button } from 'components/util'
import styles from './_signup.css'
import * as authActions from 'services/auth/actions'

const mapStateToProps = () => ({})

const mapDispatchToActions = {
  ...authActions,
}

class FacebookSignupButton extends React.Component {
  componentDidMount () {
    this.props.getFacebookLoginStatus().then(res => {
      if (res.value.status === 'connected') {
        this.handleClickSignupWithFacebook()
      }
    })
  }

  handleClickSignupWithFacebook = () => {
    // attempt a login, as they might already have FB account
    this.props.setSignupSubmitting(true)

    this.props.loginOrSignupWithFacebook()
      .then(() => {
        if (this.props.onboarding) {
          this.props.setSignupSubmitting(false)
        } else {
          this.props.onFacebookLoginSuccess()
        }
      })
      .catch(() => {
        this.props.setSignupError('unknown')
      })
  }

  render () {
    return (
      <div className={styles.facebook}>
        <Button
          disabled={this.props.disabled}
          type='facebook'
          icon='facebook_circle'
          className={styles.button}
          onClick={this.handleClickSignupWithFacebook}
        >
          <FormattedMessage
            id='auth.signup.signup_with_facebook'
            defaultMessage='Sign up with Facebook'
          />
        </Button>
      </div>
    )
  }
}

FacebookSignupButton.propTypes = {
  disabled: PropTypes.bool,
  getFacebookLoginStatus: PropTypes.func.isRequired,
  loginOrSignupWithFacebook: PropTypes.func.isRequired,
  onboarding: PropTypes.string,
  onClickSignupWithFacebook: PropTypes.func,
  onFacebookLoginSuccess: PropTypes.func,
  setSignupError: PropTypes.func,
  setSignupSubmitting: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToActions)(FacebookSignupButton)
